import { Page, CanaldeVendas } from "@/models"
import { AxiosRequestConfig } from "axios"
import { Inject } from "inversify-props"
import type { CanalDeVendasServiceAdapter } from "./adapter"

export class FindCanalDeVendasUseCase {
	@Inject('CanalDeVendasServiceAdapter')
	private canalDeVendasAdapter!: CanalDeVendasServiceAdapter

	findAll = async (params?: any, config?: AxiosRequestConfig): Promise<Page<CanaldeVendas>> =>
		this.canalDeVendasAdapter.find(params, config)

	findById = async (id: string): Promise<CanaldeVendas> =>
		this.canalDeVendasAdapter.get(id)

	findCanalDeVendaDaVitrineVirtual = async (): Promise<CanaldeVendas> =>
		this.canalDeVendasAdapter.findCanalDeVendaDaVitrineVirtual()
}